/* eslint-disable react-hooks/exhaustive-deps */

import { DISABLED_BUTTON_SUBMIT, instance2, REK_MED } from "App/constants";
import {
  InputOptionMaster,
  InputTextMaster,
  MasterButton,
  Modal,
  DatatablesFooterServerSide,
  Loading,
  TableAction,
} from "App/Component/ui";
import { Grid, TableRow } from "@material-ui/core";
import { useState } from "react";
import {
  defaultDateDisplay,
  defaultToastError,
  isNull,
} from "App/utils/helpers";
import {
  urlFilterExternal,
  urlFilterInternal,
  valueJenisRm,
} from "./../helpers";
import { useDatatables } from "App/hooks";
import { TableCell } from "@material-ui/core";
import moment from "moment";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import React, { useEffect } from "react";
import { RESET_STATE_PROFILE_REKAM_MEDIS } from "../../../ProfileRekamMedis/ui";
import { FreezeTable } from "components/organism";
import { useDispatchWrapper } from "hooks";
import {
  changePageProps,
  changeActiveMenu,
} from "App/Component/layout/Wrapper/context/actions";
import { removeZeroInFront } from "utils/all";

const ModalKunjunganBaru = ({
  setShowModal,
  formData,
  setFormData,
  title = "Kunjungan Baru",
  handleClickSelect,
  onlyInternal = false,
  withData = false,
  data = null,
  urlPatientExternal = urlFilterExternal,
  urlPatientInternal = urlFilterInternal,
  callbackBuatRekamMedis,
  withButtonBuatRekamMedis = true,
}) => {
  const [rows, setRows] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);

  const { dispatch, handleClickMenu } = useDispatchWrapper();

  const [pagination, setPagination] = useState({
    limit: 10,
    page: 1,
    count: 0,
    url: "",
  });

  const [formFilter, setFormFilter] = useState({
    nik: isNull(data?.nik) ? "" : data?.nik,
    idrm: "",
    namarm: "",
    tanggal_lahir: "",
    alamat: "",
    status: 1,
  });

  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });
  };

  const setNewData = async (
    url,
    page = pagination.page,
    limit = pagination.limit
  ) => {
    setLoading(true);
    try {
      const res = await instance2.get(url, {
        headers: {
          ...formFilter,
          idrm: removeZeroInFront(formFilter.idrm),
          limit,
          pages: page,
          jenisrm: parseInt(formData.jenisrm),
        },
      });
      setTotalData(res?.data?.meta?.count);
      const data = res?.data?.body;
      setRows(data);
      setLoading(false);
      return res;
    } catch (error) {
      setLoading(false);
      defaultToastError(error?.response?.data?.message);
      return [];
    }
  };

  const onNext = async () => {
    const url =
      parseInt(formData.jenisrm) === 1
        ? urlPatientExternal
        : urlPatientInternal;
    const currentPage = pagination.page + 1;
    await setNewData(url, currentPage, pagination.limit);
    setPagination({
      ...pagination,
      page: currentPage,
    });
  };

  const onPrevious = async () => {
    const url =
      parseInt(formData.jenisrm) === 1
        ? urlPatientExternal
        : urlPatientInternal;
    const currentPage = pagination.page - 1;
    await setNewData(url, currentPage, pagination.limit);
    setPagination({
      ...pagination,
      page: currentPage,
    });
  };

  const handleClickPageNumber = async (page) => {
    const url =
      parseInt(formData.jenisrm) === 1
        ? urlPatientExternal
        : urlPatientInternal;
    await setNewData(url, page, pagination.limit);
    setPagination({
      ...pagination,
      page,
    });
  };

  const handleChangeLimit = async (e) => {
    const url =
      parseInt(formData.jenisrm) === 1
        ? urlPatientExternal
        : urlPatientInternal;
    setPagination({
      page: 1,
      limit: parseInt(e.target.value),
    });
    await setNewData(url, 1, e.target.value);
  };

  const handleClickBuatRekamMedis = async () => {
    if (withData) {
      dispatch(changeActiveMenu(REK_MED));
      handleClickMenu({
        code: REK_MED,
        name: "Profile Rekam Medis",
      });

      const newDataFormRekamMedis = {
        patient_id_delete: "",
        patient_id_update: "",

        external: 0,
        fullname: data?.name,
        first_visit_form: "",
        nik: data?.nik,
        date: moment().format("YYYY-MM-DD"),

        // Data Pasien
        place_ob: data?.place_ob,
        date_ob_form: data?.date_ob,
        blood_type: data?.blood_type,
        gender: data?.gender,
        ethnic: data?.ethnic,
        mobile_phone_number: data?.mobile_phone,
        phone_number: data?.mobile_phone,
        religion: data?.religion,
        nip: "",
        npwp: "",
        education: data?.education,
        occupation: data?.occupation,

        // Alamat
        address_ktp: data?.address,
        address_now: data?.address,
        country: 62,

        province: "",
        province_name: "Pilih Provinsi",

        city: null,
        city_name: "Pilih Kota",

        district: "",
        district_name: "Pilih Kecamatan",

        sub_district: "",
        sub_district_name: "Pilih Kelurahan",

        is_same_with_ktp: 0,

        statuspernikahan: "",
        namaayah: "",

        // Asuransi
        insurance_id: "",
        insurance_number: "",
        company_id: 0,

        // Penanggung :
        guarantor_connection: "",
        guarantor_name: "",

        // Media Sosial
        sc_instagram: "",
        sc_whatsapp: "",
        sc_email: "",
        sc_facebook: "",
      };

      Promise.resolve(() => {
        dispatch(changePageProps(RESET_STATE_PROFILE_REKAM_MEDIS));
      }).then(() => {
        dispatch(changePageProps(newDataFormRekamMedis));
      });
    } else {
      dispatch(changeActiveMenu(REK_MED));
      handleClickMenu({
        code: REK_MED,
        name: "Profile Rekam Medis",
      });
    }

    if (callbackBuatRekamMedis !== undefined) {
      callbackBuatRekamMedis();
    }
  };

  const resetPagination = () => {
    setPagination({
      count: 0,
      limit: 10,
      page: 1,
    });
  };

  useEffect(() => {
    if (!isNull(data?.nik)) {
      setNewData();
    }
  }, []);

  return (
    <Modal title={title} width='70%' show={setShowModal}>
      <FormFilterRekamMedis
        handleChange={handleChange}
        formFilter={formFilter}
        setRows={setRows}
        formData={formData}
        setFormData={setFormData}
        setNewData={setNewData}
        handleClickBuatRekamMedis={handleClickBuatRekamMedis}
        onlyInternal={onlyInternal}
        withButtonBuatRekamMedis={withButtonBuatRekamMedis}
        urlPatientInternal={urlPatientInternal}
        resetPagination={resetPagination}
      />

      <Loading show={loading} />

      <div className='mt-2'>
        <TableListRekamMedis
          rows={rows}
          handleClickSelect={handleClickSelect}
          totalData={totalData}
          setNewData={setNewData}
          pagination={pagination}
          onNext={onNext}
          onPrevious={onPrevious}
          currentPage={pagination.page}
          handleClickPageNumber={handleClickPageNumber}
          handleChangeLimit={handleChangeLimit}
          loading={loading}
        />
      </div>
    </Modal>
  );
};

export const defaultButtonSearch = {
  label: "CARI",
  color: "green",
  state: false,
};

export const FormFilterRekamMedis = ({
  handleChange,
  formFilter,
  setRows,
  formData,
  setFormData,
  handleClickBuatRekamMedis,
  setNewData,
  onlyInternal = false,
  withButtonBuatRekamMedis,
  resetPagination,
  urlPatientExternal = urlFilterExternal,
  urlPatientInternal = urlFilterInternal,
}) => {
  const [disabled, setDisabled] = useState(defaultButtonSearch);
  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setDisabled(DISABLED_BUTTON_SUBMIT);

      if (parseInt(formData.jenisrm) === 1) {
        await setNewData(urlPatientExternal, 1, 10);
        resetPagination();
      } else if (parseInt(formData.jenisrm) === 2) {
        await setNewData(urlPatientInternal, 1, 10);
        resetPagination();
      }
      setDisabled(defaultButtonSearch);
    } catch (error) {
      setRows([]);
      setDisabled(defaultButtonSearch);
      defaultToastError(error?.response?.data?.message);
    }
  };
  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <Grid item sm={2}>
            <InputTextMaster
              name='idrm'
              label='ID RM'
              id='idrm'
              type='number'
              placeholder='ID RM'
              autoFocus={true}
              value={formFilter.idrm}
              onChange={handleChange("idrm")}
            />
          </Grid>
          <Grid item sm={2}>
            <InputTextMaster
              name='namarm'
              label='NAMA RM'
              id='namarm'
              placeholder='Nama RM'
              value={formFilter.namarm}
              onChange={handleChange("namarm")}
            />
          </Grid>
          <Grid item sm={2}>
            <InputTextMaster
              name='nik'
              label='NIK'
              id='nik'
              placeholder='NIk'
              value={formFilter.nik}
              onChange={handleChange("nik")}
            />
          </Grid>

          <Grid item sm={2}>
            {onlyInternal ? (
              <InputTextMaster
                name='jenisrm'
                label='JENIS RM'
                id='jenisrm'
                placeholder='jenisrm'
                value='INTERNAL'
                readOnly={true}
                disabled={true}
              />
            ) : (
              <InputOptionMaster
                name='jenisrm'
                label='JENIS RM'
                id='jenisrm'
                withSearch={false}
                data={valueJenisRm}
                value={formData.jenisrm}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    jenisrm: e.target.value,
                  });
                }}
              />
            )}
          </Grid>

          <Grid item sm={2}>
            <InputOptionMaster
              name='status'
              label='STATUS'
              id='status'
              withSearch={false}
              data={[
                {
                  value: 0,
                  label: "Semua",
                },
                {
                  value: 1,
                  label: "Aktif",
                },
                {
                  value: 2,
                  label: "Tidak Aktif",
                },
              ]}
              value={formFilter.status}
              onChange={handleChange("status")}
            />
          </Grid>

          <Grid item sm={2}>
            <InputTextMaster
              name='tanggal_lahir'
              label='TANGGAL LAHIR'
              id='tanggal_lahir'
              placeholder='Tanggal Lahir'
              type='date'
              value={formFilter.tanggal_lahir}
              onChange={handleChange("tanggal_lahir")}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          {withButtonBuatRekamMedis && (
            <MasterButton
              className={"mt-1"}
              type='button'
              color='green'
              style={{
                marginRight: "0.5rem",
              }}
              onClick={handleClickBuatRekamMedis}
              name='BUAT PROFIL REKAM MEDIS BARU'
              size='md'
            />
          )}

          <MasterButton
            className={"mt-1"}
            type='submit'
            outline={true}
            color={disabled.color}
            name={disabled.label}
            size='md'
          />
        </Grid>
      </form>
    </>
  );
};

const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID RM",
    minWidth: "100px",
  },
  {
    id: "nik",
    disablePadding: true,
    label: "NIK",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "fullname",
    disablePadding: true,
    label: "NAMA RM",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "status",
    disablePadding: false,
    label: "STATUS",
    minWidth: "100px",
    sort: false,
  },
  {
    id: "gender",
    disablePadding: true,
    label: "JENIS KELAMIN",
    sort: false,

    minWidth: "150px",
  },
  {
    id: "date_ob",
    disablePadding: true,
    label: "TANGGAL LAHIR",
    sort: false,

    minWidth: "180px",
  },
  {
    id: "address_now",
    disablePadding: true,
    label: "ALAMAT",
    sort: false,

    minWidth: "150px",
  },
  {
    id: "mobile_phone_number",
    disablePadding: true,
    label: "NO HP",
    sort: false,

    minWidth: "100px",
  },
  {
    id: "guarantor_name",
    disablePadding: true,
    label: "PENANGGUNG",
    sort: false,

    minWidth: "100px",
  },
];

const TableListRekamMedis = ({
  rows,
  totalData,
  onNext,
  onPrevious,
  currentPage,
  handleClickPageNumber,
  handleChangeLimit,
  pagination,
  handleClickSelect,
}) => {
  const { order, orderBy, length, handleRequestSort } = useDatatables({
    rows: rows,
    orderByDefault: "fullname",
    orderByRow: ["fullname"],
  });

  return (
    <>
      <FreezeTable
        headCells={headCells}
        handleRequestSort={handleRequestSort}
        order={order}
        length={length}
        orderBy={orderBy}>
        {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
          return (
            <TableRow hover key={index}>
              <TableCell align='center'>{index + 1}</TableCell>

              <TableCell width='5%' align='center'>
                <TableAction
                  isUpdate={false}
                  isDelete={false}
                  isSelect={true}
                  clickSelect={() => handleClickSelect(row)}
                />
              </TableCell>

              <TableCell>{row?.id}</TableCell>
              <TableCell>{row?.nik}</TableCell>
              <TableCell>{row?.fullname}</TableCell>
              <TableCell>
                <MasterButton
                  style={{ borderRadius: 20 }}
                  name={row.status ? "Aktif" : "Tidak Aktif"}
                  color={row.status ? "lightgreen" : "secondary"}
                  type='button'
                  disabled
                />
              </TableCell>
              <TableCell>
                {row?.gender === 1 ? "Laki-laki" : "Perempuan"}
              </TableCell>
              <TableCell>{defaultDateDisplay(row?.date_ob, false)}</TableCell>
              <TableCell>{row?.address_now}</TableCell>
              <TableCell>{row?.mobile_phone_number}</TableCell>
              <TableCell>{row?.guarantor_name}</TableCell>
            </TableRow>
          );
        })}
        {length === 0 && (
          <TableRow>
            <TableCell align='center' colSpan={headCells.length}>
              Tidak ada data
            </TableCell>
          </TableRow>
        )}
      </FreezeTable>
      <DatatablesFooterServerSide
        totalData={totalData}
        pagination={pagination}
        handleChangeLimit={handleChangeLimit}
        onPrevious={onPrevious}
        onNext={onNext}
        currentPage={currentPage}
        handleClickPageNumber={handleClickPageNumber}
      />
    </>
  );
};

export default ModalKunjunganBaru;
